import { render } from "./TarifaEnvio.vue?vue&type=template&id=48e90cff"
import script from "./TarifaEnvio.vue?vue&type=script&lang=js"
export * from "./TarifaEnvio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__